import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
/*
使用方法
1.import {myMixin} from '@/mixins/tool.js'
2.mixins:[myMixin]
*/
export const myMixin ={
  provide() {
    return {
      initData:this.initData,
      getDataSource:this.getDataSource,
      getDays: this.getDays,
      getSeconds:this.getSeconds,
      getLocalTime:this.getLocalTime,
      getDetailTime:this.getDetailTime,
      getDaysNum:this.getDaysNum,
      toUri:this.toUri,
      rootpath:this.rootpath,
      reload:this.reload,
      loadImg:this.loadImg,
      nowbg:this.nowbg,
      isPage:this.isPage,
      routeName:this.routeName,
      getApps:this.getApps,
      backtotopNow:this.backtotopNow,
      getQueryString:this.getQueryString,
      filterZimu:this.filterZimu,
      userLoaded:this.userLoaded,
      isWxwork:this.isWxwork,
      getProfile:this.getProfile
    }
  },
  mounted(){
    let self = this;
    document.addEventListener("DOMContentLoaded", function(event) {
      self.sdk_start.push(1);
     });
  },
  data(){
      return{
        zh_CN,
        RouterShow:true,
        userProfile:{},
        sdk_start:[]
    }
  },
  watch:{
    sdk_start:{
      handler(val,oldval){
        if(val.length>1){
            let self = this;
            const s = document.createElement('script');
            s.type = 'text/javascript';
            s.src = "https://cloud.ketanyun.cn/infoplus/static/js/sdk/infoplus.sdk.js";
            document.body.appendChild(s);

            if(s.readyState){
                s.onreadystatechange=function(){
                if(s.readyState=='complete'||s.readyState=='loaded'){
                    s.onreadystatechange=null;

                    var check = InfoPlusSDK.checkBrowser();
                    if(!check){
                        return false;
                    }else{
                        var apiMessageUrl= `${window.commonApi.KNOWLEDGE_BOT_URL}/infoplus/message/sub`;
                        InfoPlusSDK.message.create(self.userProfile.id, apiMessageUrl).sub("task", function(message){
                          if(self.isCanRefresh){
                              self.reloadInfoNum();
                              self.initData();
                              self.reload();
                          }
                    });
                }
                console.log('check',check);
                }
              }
            }else{
              s.onload=function(){
                var check = InfoPlusSDK.checkBrowser();
                if(!check){
                  return false;
                }else{
                  var apiMessageUrl= `${window.commonApi.KNOWLEDGE_BOT_URL}/infoplus/message/sub`;
                    InfoPlusSDK.message.create(self.userProfile.id, apiMessageUrl).sub("task", function(message){
                      if(self.isCanRefresh){
                          self.reloadInfoNum();
                          self.initData();
                          self.reload();
                      }
                  });
                }
                console.log('check',check);
              }
            }
            }
      },
      deep:true
    },
    targetMessage:{
      handler(val,oldval){
        if(val!=oldval){
          let key = val.split('#');
          this.$message[key[0]](key[1]);
        }
      },
      deep:true
    },
    getAuth:{
      handler(val,oldval){
        if(val!=oldval){
          this.userLoaded();
        }
      },
      deep:true
    },
  },
  props: {
    msg: {
    type:String,
    default:()=>{return ''}
    }
  },
  methods:{
    moment,
    isPage(str){
      if(this.$route.name === str){
        return true;
      }else{
        return false;
      }
    },
    reloadInfoNum(){
        this.$store.dispatch('metodoLength');
				this.$store.dispatch('ccsLength');
        if(this.todoBoolean){
            this.$store.dispatch('metodoLength',this.todoBoolean);
        }
    },
    backtotopNow(){
      //console.log(this.$refs.ScrollTop);
      this.$refs.ScrollTop.scrollToTop();
    },
    reload(){
        this.RouterShow = false;
        this.$nextTick(function () {
          this.RouterShow = true;
        });
    },
    getMobile() {
        var flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );
        if (flag === null) {
          return false;
        } else {
          return true;
        }
    },
    getQueryString(name,nowHref){
        if(location.href || nowHref){
            let hrefStr = location.href || nowHref;
            if(hrefStr.split("?").length > 1){
                  hrefStr = hrefStr.split("?")[1];
                  let paramsArr = hrefStr.split('&');
                  let paramsObj = {};
                  for(let i in paramsArr){
                      let miniArr = paramsArr[i].split("=");
                      let ikey = miniArr[0];
                      miniArr.shift();
                      let ival = miniArr.join("");
                      paramsObj[ikey] = ival;
                  }
                  console.log(paramsObj);
                  return paramsObj[name];
            }
        }else{
          return null;
        }
    },
      // 过滤掉第一个字母
    filterZimu(val){
        let rag = /^[A-Za-z]+$/;
        if (val){
            let first = val.slice(0,1);
            let end = val.slice(1,val.length);
            if (rag.test(first)){
                return end;
            }else {
                return val;
            }
        }
    },
    userLoaded(e){
      this.getProfile();
      this.getApps();
    },
    loadImg(src){
      var imgA = document.createElement('img');
      var load = true;
      imgA.src = src;
      imgA.addEventListener('error',()=>{
        load = false;
      });
      return load;
    },
    nowbg(str){
      let userInfo = this.$store.getters.getUserInfo;
      let name = str || 'banner-index';
      if(userInfo&&userInfo.enterprise){
        return location.origin + "/infoplus/file/enterprise/" + userInfo.enterprise.id + "/icon/" + name;
      }else{
        return false
      }
    },
    getApps(){
          let filterApps = null;
          if(this.appsFilter){
            filterApps = this.appsFilter;
          }
          this.$store.dispatch('fetchAppList',{filterApps});

          //暴露一个参数如果是机器人模式，则去拿另一个接口的apps
          if(this.hasRobot){
            window.aiDialog.createRobot();
            this.$store.dispatch('manageApp/getSearchResult',{seq:''});
          }
          let user = this.$store.getters.getEmail;
            if(!localStorage.getItem(`${user}_top`)){
                localStorage.setItem(`${user}_top`,'start');
            }
    },
    getDays(time){
      let minute = (moment(new Date().getTime()).diff(moment(time*1000), 'minute'))
      let hour = (moment(new Date().getTime()).diff(moment(time*1000), 'hour'))
      let day = (moment(new Date().getTime()).diff(moment(time*1000), 'day'))
      let month = (moment(new Date().getTime()).diff(moment(time*1000), 'month'))
      let year = (moment(new Date().getTime()).diff(moment(time*1000), 'year'))
      if(minute<60){
        return `${minute+1}分钟前`
      }else if(hour<24){
        return  `${hour}小时前`
      }else if(day<30){
        return `${day}天前`
      }else if(month<12){
        return `${month}月前`
      }else{
        return `${year}年前`
      }
    },
    getDetailTime(time){
      let timeStr = moment(time*1000).format('YYYY-MM-DD hh:mm');
      return timeStr;
    },
    getDaysNum(time) {
      let day = moment(new Date().getTime()).diff(moment(time * 1000), "day");
      return `${day}天`;
    },
    rootpath(){
      return "@/assets/todoCenter/default/images";
    },
    routeName(){
      return this.$route.name;
    },
    getSeconds(time){
      let seconds = moment(time).valueOf();
      return seconds
    },
    getLocalTime(time){
      let timeStr = moment(time*1000).format('YYYY-MM-DD');
      return timeStr;
    },
    initData(route){
      let dataName = route || this.$route.name;
      if(dataName === 'apply'){
        dataName = 'todo';
      }
      this.$store.dispatch('ClearQ',{dataName});
    },
    getDataSource(name){
      let dataName = name || this.$route.name;
      if(dataName === 'apply'){
        dataName = 'todo';
      }
      return this.$store.getters.getDataSource[dataName];
    },
    isWxwork: function () {
        let flag = navigator.userAgent.match(/(wxwork)/i);
        if (flag === null) {
          return false;
        } else {
          return true;
        }
    },
    toUri( appUrl , preview, remark){
        var isMobile = false;
        var flag = navigator.userAgent.match(
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );
        if (flag != null) {
            isMobile = true;
        }
        let query = {};
        if(isMobile){
            query.back = 1;
            query.x_posted = true;
        }

        if(remark === true || remark === false){
            query.showRemark = remark;
        }
      
        if(preview){
            if(appUrl.indexOf('preview')===-1){
                query.preview = preview === 'yes'?true:false;
            }else{
              if(preview === 'yes'){
                  appUrl = appUrl.replace("preview=false","preview=true")
                }else{
                  appUrl = appUrl.replace("preview=true","preview=false")
                }
            }
        }
        let len = Object.keys(query).length;
        if(len>0){
            let after_url = '';
            let i = 1;
            for(let key in query){
                after_url = i<len?after_url+`${key}=${query[key]}&`:after_url+`${key}=${query[key]}`;
                i++;
            }
            if(appUrl.indexOf("?")>-1) {
                appUrl += "&" + after_url;
            }else{
                appUrl += "?" + after_url;
            }

        }
        

        if(isMobile){
            // console.log(appUrl);
            location.href = appUrl;
        }else{
            // console.log(appUrl);
            window.open(appUrl);
        }

    },
    async getProfile(){
		    var self = this;
        await this.$axios.get(`${window.commonApi.INFOPLUS_URL}/me/profile`).then((res)=>{
          if (res.data.errno === 0 ) {
              self.userProfile=res.data.entities[0];
              self.$store.commit('setUserInfo',self.userProfile);
              self.sdk_start.push(1);
              // console.log(self.sdk_start,self.userProfile.id,'id也获取到了');
				  }
        }).catch(error => {
			    console.log(error); //请求失败返回的数据
		    });
	  },
  },
  computed:{
    getAuth(){
      return this.$store.getters.getAuth.access_token
    },
    membership(){
      return sessionStorage.getItem('membership') || this.getQueryString('membership');
    },
    isCanRefresh(){
      return this.$store.getters.getState.isCanFresh;
    },
    targetMessage(){
      return this.$store.getters.getState.targetMessage;
    }
  }

}





// WEBPACK FOOTER //
// ./src/mixins/tool.js